import { graphql, useStaticQuery } from "gatsby"
import React, { FC } from "react"
import Item, { Props as ItemProps } from "../molecules/goodsList/Item"
import classes from "./GoodsList.module.scss"

const items: (Omit<ItemProps, "image"> & { image: string })[] = [
  {
    title: {
      ja: "JMoFオリジナルボールペン（SARASA）",
      en: "JMoF Original Ballpoint Pen (SARASA)",
    },
    description: {
      ja:
        "お絵描きでも普段使いでも、何気ない日常にJMoFの思い出をちょっと思い起こさせてくれるボールペンです。",
      en:
        "Whether for drawing or regular use, it’s a pen that can help bring out a teeny memory of JMoF on a normal day.",
    },
    price: 200,
    image: "JMF22_RG_goods_1.png",
  },
  {
    title: {
      ja: "七匹の侍 フェイスタオル",
      en: "The Seven Samurai Face Towel",
    },
    description: {
      ja:
        "JMoF公式グッズに使いやすいフェイスタオルがついにラインアップしました！",
      en:
        "A face towel that’s easy-to-use has finally made its way to the JMoF Official Goods line-up!",
    },
    price: 1500,
    image: "JMF22_RG_goods_2.png",
  },
  {
    title: {
      ja: "七匹の侍 扇子",
      en: "The Seven Samurai Folding Fan",
    },
    description: {
      ja: (
        <>
          <p>
            {/* eslint-disable no-irregular-whitespace */}
            和風小物の大定番！　使ってヨシ、飾ってヨシ！
            {/* eslint-enable no-irregular-whitespace */}
            <br />
            急に大喜利が始まってもこれで安心。
          </p>
          <p>
            サイズ：7寸30間
            <br />
            仕様：フルカラー布貼り、箱・収納袋付属、携帯に嬉しい房付き
          </p>
        </>
      ),
      en: (
        <>
          <p>
            The standard Japanese-style accessory! Using it is great, hanging it
            is also great!
            <br />
            Banging it on the table, too, is great!
          </p>
          <p>
            Size: About 21cm, 30 ridges
            <br />
            Features: Full color cloth wrap, box and storage bag included, a
            tassel perfect for carriage included
          </p>
        </>
      ),
    },
    price: 3500,
    image: "JMF22_RG_goods_3.png",
  },
  {
    title: {
      ja: "七匹の侍 オリジナルモバイルブースター",
      en: "The Seven Samurai Original Mobile Charger",
    },
    description: {
      ja: (
        <>
          <p>
            素敵なイラストが入ったモバイルブースター。スマホの予備バッテリーや着ぐるみ着用時の空冷ファン用にお使いいただけます。
            <br />
            お部屋に飾ってもよい一品です。
          </p>
          <p>
            サイズ：約H99 × W63 × D14 mm
            <br />
            容量：5,000 ｍAh
          </p>
        </>
      ),
      en: (
        <>
          <p>
            A mobile charger with a wonderful art on the cover. You can use it
            as a backup battery for your smartphone or for the cooling fan when
            fursuiting.
            <br />
            It’s a product that can be displayed in your room as well.
          </p>
          <p>
            Size: About 99 mm height, 63 mm width, 14 mm depth
            <br />
            Capacity: 5,000 mAh
          </p>
        </>
      ),
    },
    price: 3000,
    image: "JMF22_RG_goods_4.png",
  },
  {
    title: {
      ja: "JMoF 2022 公式Tシャツ",
      en: "JMoF 2022 Official T-Shirt",
    },
    description: {
      ja: (
        <>
          <p>
            定番のJMoF公式Tシャツ。今回のイラストは昨年のオンライン販売に引き続きぐる（Grrr）様に描いていただきました！
          </p>
          <p>サイズ：S/M/L/XL/XXL/XXXL</p>
        </>
      ),
      en: (
        <>
          <p>
            The standard JMoF Official T-Shirt. This time’s art was drawn for us
            by Grrr, artist for the last year’s online shop.
          </p>
          <p>Size: S/M/L/XL/XXL/XXXL</p>
        </>
      ),
    },
    price: 2500,
    image: "JMF22_RG_goods_5.png",
  },
  {
    title: {
      ja: "JMoF 2022 トートバッグ",
      en: "JMoF 2022 Tote Bag",
    },
    description: {
      ja: (
        <>
          <p>
            同人誌やスケブ、ボドゲといった大きめの荷物を持ち歩ける、頑丈でカッコいいトートバッグ。
            <br />
            エコバッグとしてもご利用できます。
          </p>
          <p>
            サイズ：W360 × H370 × D110 mm
            <br />
            容量：約10 L<br />
            材質：コットン、ポリエステル
          </p>
        </>
      ),
      en: (
        <>
          <p>
            A durable and cool tote bag that lets you carry around your largish
            items, like fanbooks, sketchbooks, and boardgames.
            <br />
            You can use it as a bag for groceries too.
          </p>
          <p>
            Size: 360 mm width, 370 mm height, 110 mm depth
            <br />
            Capactiy: About 10 L<br />
            Materials: Cotton, Polyester
          </p>
        </>
      ),
    },
    price: 1500,
    image: "JMF22_RG_goods_6.png",
  },
  {
    title: {
      ja: "JMoF 2022 ピンバッジ",
      en: "JMoF 2022 Pin Badge",
    },
    description: {
      ja: (
        <>
          <p>毎度お馴染みのピンバッジ。今回もご用意しております！</p>
          <p>
            サイズ：⌀25 mm
            <br />
            カラー：シルバー
          </p>
        </>
      ),
      en: (
        <>
          <p>
            The familiar pin badge, present every time. We’re preparing them
            this time too!
          </p>
          <p>
            Size: ⌀ 25 mm
            <br />
            Color: Silver
          </p>
        </>
      ),
    },
    price: 600,
    image: "JMF22_RG_goods_7.png",
  },
  {
    title: {
      ja: "JMoF 2022 ステッカー",
      en: "JMoF 2022 Sticker",
    },
    description: {
      ja:
        "JMoFデザインのステッカー。スーツケースやお車に貼り付けてFURRYを演出しよう！",
      en:
        "JMoF Design Sticker. Stick it to something like your suitcase or car and show off your FURRY!",
    },
    price: 300,
    image: "JMF22_RG_goods_8.png",
  },
  {
    title: {
      ja: "JMoF 2022 ポスター",
      en: "JMoF 2022 Poster",
    },
    description: {
      ja: (
        <>
          <p>
            その回のJMoFテーマを象徴する大迫力のポスター。JMoFの思い出を飾ろう。
          </p>
          <p>サイズ：B2</p>
        </>
      ),
      en: (
        <>
          <p>
            A powerful poster featuring this time’s JMoF theme. Let’s decorate
            your room with a JMoF memory.
          </p>
          <p>Size: JIS B2</p>
        </>
      ),
    },
    price: 300,
    image: "JMF22_RG_goods_9.png",
  },
]
const GoodsList: FC = () => {
  const images = useStaticQuery<GatsbyTypes.GoodsImagesQuery>(graphql`
    query GoodsImages {
      images: allFile(filter: { relativePath: { regex: "$/store/" } }) {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              fluid(maxWidth: 450, maxHeight: 450) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)
  return (
    <div className={classes.Wrapper}>
      {items.map(item => (
        <Item
          key={item.title.ja}
          {...item}
          image={
            images.images.edges.find(edge =>
              edge.node.relativePath.endsWith(item.image)
            )?.node.childImageSharp?.fluid
          }
        />
      ))}
    </div>
  )
}
export default GoodsList
